import { RootApplicationEffects } from '@state/root';
import { EmployeesPageEffects } from '@state/employees';
import { RouterEffects } from '@state/router';
import { InvoicesEffects } from '@state/invoices';
import { TerminalEffects } from '@state/settings';

export const effects = [
  RootApplicationEffects,
  EmployeesPageEffects,
  RouterEffects,
  InvoicesEffects,
  TerminalEffects
];
